module.exports = __webpack_public_path__ + "static/media/galerija_2021 (10).037dc08f.jpg";